export default __webpack_public_path__ + "static/media/photo--sm--117.a5558537.jpg";